import React from 'react';
import moment from 'moment';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import get from 'lodash/get';
import {
  CardContainer,
  PostContentData,
  PostHeading,
  PostImage,
  NewsItemBottom,
} from './news.card.styled';
import StaticPicture from '../StaticImage';

const PostCard = ({
  title,
  featuredImage,
  date,
  imgTitle,
  postsFields,
  noContent,
  slug,
}) => {
  const postSubTitle = get(postsFields, 'postSubTitle');
  const editedContent = postSubTitle ? postSubTitle.substring(0, 100) : null;
  const editedDate = moment(date).format('MMMM D, YYYY');
  const authorNames = get(postsFields, 'author');
  const cardImg = get(featuredImage, 'node.mediaItemUrl');
  const cardImgTitle = get(featuredImage, 'node.title');
  const cardOptimizeImage = get(featuredImage, 'node.localFile');

  return (
    <CardContainer className='news-post' data-testid='news-card'>
      <PostImage to={`/news/${slug}/`}>
        {cardOptimizeImage ? (
          <GatsbyImage
            image={getImage(cardOptimizeImage)}
            alt={cardImgTitle}
          />
        ) : (
          <StaticPicture imgFile={cardImg} altText={cardImgTitle} size='m' />
        )}
        <figcaption>{imgTitle}</figcaption>
      </PostImage>
      <Link className='contain' to={`/news/${slug}/`} title={title}>
        <PostContentData>
          <PostHeading>
            {title}
          </PostHeading>
          {noContent ? null : (
            <div className='content' data-testid='desc-content'>
              <p>
                {editedContent}
                ...
              </p>
            </div>
          )}
        </PostContentData>
      </Link>
      <NewsItemBottom>
        {authorNames &&
          Array.isArray(authorNames) &&
          authorNames.map((value, index) => (
            <span className='author-container' key={index}>
              <Link
                to={`/author/${value.slug}/`}
                className='author-name'
                data-testid='author-name'
                title={value.name}
              >
                {value.name}
              </Link>
              {index !== authorNames.length - 1 && ', '}
            </span>
          ))}
        {authorNames && Array.isArray(authorNames) && authorNames.length > 0 && editedDate && <span className='divider' />}
        {editedDate && <span>{editedDate}</span>}
      </NewsItemBottom>
    </CardContainer>
  );
};

export default PostCard;
